import { IPaginationResponse, IInstitutionNotification } from "../types";
import {
  ILocationAnalysisEvent,
  ILocationAnalysisEventParams,
  ILocationAnalysisEventsParams,
} from "./types";
import { rootApi } from "../rootApi";

export const locationAnalysisEventApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    locationAnalysisEvents: builder.query<
      IPaginationResponse<ILocationAnalysisEvent>,
      ILocationAnalysisEventsParams
    >({
      query: ({ limit, ordering, offset, tab, type, issuerId }) => ({
        url: `location-analysis-events/`,
        params: {
          limit,
          ordering,
          offset,
          tab,
          type: type || undefined,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["locationAnalysisEvents"],
    }),
    locationAnalysisEvent: builder.query<
      ILocationAnalysisEvent,
      ILocationAnalysisEventParams
    >({
      query: ({ id }) => ({
        url: `location-analysis-events/${id}/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "locationAnalysisEvents", id: arg.id },
      ],
    }),
    sendLocationAnalysisReport: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `location-analysis-events/${id}/send-report/`,
        method: "POST",
      }),
      invalidatesTags: (_result, _, arg) => [
        { type: "locationAnalysisEvents", id: arg.id },
        { type: "institutionNotifications", id: arg.id },
      ],
    }),
    locationInstitutionNotifications: builder.query<
      IInstitutionNotification[],
      { eventId: string; type?: string }
    >({
      query: ({ eventId, type }) => ({
        url: `location-analysis-events/${eventId}/institution-notifications/`,
        params: {
          type: type || undefined,
        },
      }),
      providesTags: (_result, _, arg) => [
        { type: "institutionNotifications", id: arg.eventId },
      ],
    }),
  }),
});

export const {
  useLocationAnalysisEventQuery,
  useLocationAnalysisEventsQuery,
  useSendLocationAnalysisReportMutation,
  useLocationInstitutionNotificationsQuery,
} = locationAnalysisEventApis;
